module.exports = __webpack_public_path__ + "static/favicon-9f92820de02256db5ca91f3fdb190b2f.ico";